import { render } from "./TotalStats.vue?vue&type=template&id=4554b75c&scoped=true"
import script from "./TotalStats.vue?vue&type=script&lang=js"
export * from "./TotalStats.vue?vue&type=script&lang=js"

import "./TotalStats.vue?vue&type=style&index=0&id=4554b75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4554b75c"]])

export default __exports__